import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.10573 5.10573C6.93422 3.27724 9.41418 2.25 12.0001 2.25C14.5859 2.25 17.0659 3.27724 18.8944 5.10573C20.7229 6.93422 21.7501 9.41418 21.7501 12.0001C21.7501 14.5859 20.7229 17.0659 18.8944 18.8944C17.0659 20.7229 14.5859 21.7501 12.0001 21.7501C9.41418 21.7501 6.93422 20.7229 5.10573 18.8944C3.27724 17.0659 2.25 14.5859 2.25 12.0001C2.25 9.41418 3.27724 6.93422 5.10573 5.10573ZM6.72085 5.66019L18.3399 17.2793C19.5692 15.8031 20.2501 13.9367 20.2501 12.0001C20.2501 9.812 19.3809 7.71357 17.8337 6.16639C16.2865 4.6192 14.1881 3.75 12.0001 3.75C10.0634 3.75 8.19699 4.43093 6.72085 5.66019ZM17.2793 18.3399L5.66019 6.72085C4.43093 8.19699 3.75 10.0634 3.75 12.0001C3.75 14.1881 4.6192 16.2865 6.16639 17.8337C7.71357 19.3809 9.812 20.2501 12.0001 20.2501C13.9367 20.2501 15.8031 19.5692 17.2793 18.3399Z"
        fill={colorValue}
      />
    </svg>
  );
};
